module.exports = __webpack_public_path__ + "static/media/request-virtual-card-48x48.98058f38.svg";